import { css } from "@styled-system/css";

export function NotFoundPage() {
  return (
    <div
      className={css({
        display: "flex",
        flexDir: "column",
        alignItems: "center",
        justifyContent: "center",
        minH: "screen",
        gap: "4",
      })}
    >
      <span className={css({ fontFamily: "mono", fontSize: "64", color: "text.subtlest" })}>
        404
      </span>
      <p className={css({ color: "text.subtle", fontSize: "14" })}>
        Page not found
      </p>
      <a
        href="/"
        className={css({
          color: "hal.blue",
          fontSize: "14",
          textDecoration: "underline",
          _hover: { opacity: 0.8 },
        })}
      >
        Return home
      </a>
    </div>
  );
}
